import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileQuoteRequestService {
  files = new Subject<any>();
  constructor() { }
  setFiles(files: any) {
    this.files.next(files);
  }

  getFiles(): Observable<any> {
    return this.files.asObservable();
  }
}
